import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';
import moment from 'moment';

export class InvoicesReport  extends  AbstractReport {}
AccessorsMutatorsDecorator(
    'id',
    'ident',
    'invoice_date',
    'invoice_date_formatted',
    'created_at',
    'created_at_formatted',
    'from_date',
    'from_date_formatted',
    'to_date',
    'to_date_formatted',
    'amount',
    'amount_formatted',
    'reservation_id',
    'reservation_ident',
    'reservation_status',
    'reservation_status_formatted',
    'guest_name',
    'guest_id',
    'room_name',
    'credit_note_ident',
    'credit_note_comment',
    'type',
    'index'
)(InvoicesReport);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/financial/invoices-report.model.js